import React from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import {
  FooterWrapper,
  FooterSocialIconsWrapper,
  FooterNavInfo,
  FooterTopInfo,
  LogoWrapper,
  TextWrapper,
  ExeltisLogo,
} from './style';
import { SectionContainer } from 'components/Container';
import LogoExeltisWhite from 'assets/logo/logo-exeltis-white.svg';
import LogoRegenesis from 'assets/logo/logo-regenesis-footer.svg';
import CareIcon from 'assets/icon/icone-mulheres-gestacao.svg';
import YoutubeIcon from 'assets/icon/icone-youtube.svg';
import FacebookIcon from 'assets/icon/icone-face.svg';
import InstagramIcon from 'assets/icon/icone-instagram.svg';
import TelegramIcon from 'assets/icon/icone-telegram.svg';
import TikTokIcon from 'assets/icon/icone-tiktok.svg';

interface IFooter {
  backgroundColor: string;
  hasLogo: boolean;
}

const Footer: React.FC<IFooter> = ({ backgroundColor, hasLogo }) => {
  return (
    <FooterWrapper>
      <SectionContainer>
        <FooterTopInfo>
          {hasLogo && (
            <LogoWrapper>
              <Link to="/">
                <img src={LogoRegenesis} alt="Regenesis" />
                {/* <img src={LogoExeltisWhite} alt="exeltis" /> */}
              </Link>
            </LogoWrapper>
          )}

          <TextWrapper>
            <p>
              Do resultado positivo à amamentação, conteúdos científicos e especializados com muito acolhimento para apoiar todas as fases da sua gestação.
            </p>
          </TextWrapper>

          <FooterSocialIconsWrapper>
            {/* <a
              href="https://t.me/mulheregestacao?utm_medium=social&utm_source=linktree&utm_campaign=grupo+do+telegram%3A+mulher+e+gesta%C3%A7%C3%A3o+by+regenesis"
              target="_blank"
              rel="noreferrer"
            >
              <img src={TelegramIcon} alt="telegram" />
            </a> */}
            <a
              href="https://www.tiktok.com/@regenesisbrasil"
              target="_blank"
              rel="noreferrer"
            >
              <img src={TikTokIcon} alt="TikTok" />
            </a>

            <a
              href="https://www.youtube.com/channel/UCIqmGUeQa39jrAdd_5uW-Kw"
              target="_blank"
              rel="noreferrer"
            >
              <img src={YoutubeIcon} alt="youtube" />
            </a>

            <a
              href="https://www.facebook.com/regenesisbrasil"
              target="_blank"
              rel="noreferrer"
            >
              <img src={FacebookIcon} alt="facebook" />
            </a>

            <a
              href="https://www.instagram.com/regenesisbrasil/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={InstagramIcon} alt="instagram" />
            </a>

            <a
              href="https://mulheregestacao.com.br/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={CareIcon} alt="care" />
            </a>
          </FooterSocialIconsWrapper>
        </FooterTopInfo>

        <ExeltisLogo>
          <div className="line"></div>
          <img src={LogoExeltisWhite} alt="Exeltis" />
        </ExeltisLogo>

        <FooterNavInfo>
          <Link to="/privacidade">Política de privacidade</Link>

          <Link to="/termos">Termo de Uso</Link>

          <Link to="/faq">Perguntas frequentes</Link>

          <Link to="/fale-conosco">Fale com a gente</Link>
        </FooterNavInfo>
      </SectionContainer>
    </FooterWrapper>
  );
};

export default Footer;
